function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ReservesTemplate = require('./reserves.template');
console.log;
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ReservesOverlay = /*#__PURE__*/function () {
  function ReservesOverlay(app, mod) {
    _classCallCheck(this, ReservesOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(ReservesOverlay, [{
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pickUnitAndTriggerCallback",
    value: function pickUnitAndTriggerCallback() {
      var _this = this;
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allies';
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.render(faction);
      document.querySelectorAll('.reserves-overlay .units .army-tile').forEach(function (el) {
        el.onclick = function (e) {
          var id = e.currentTarget.id;
          document.querySelectorAll('.reserves-overlay .units .army-tile').forEach(function (el) {
            el.onclick = function (e) {};
          });
          if (mycallback) {
            mycallback(id);
          }
          _this.hide();
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allies';
      this.pushHudUnderOverlay();

      //
      // if already visible, don't reload
      //
      if (this.visible == true) {
        if (document.querySelector('.zoom_overlay')) {
          return;
        }
      }
      this.visible = true;
      this.overlay.show(ReservesTemplate(faction));
      var arb = document.querySelector('.reserves-overlay .units');
      arb.innerHTML = '';
      if (faction == 'allies') {
        for (var z = 0; z < this.mod.game.spaces['arbox'].units.length; z++) {
          if (this.mod.game.spaces['arbox'].units[z].damaged) {
            arb.innerHTML += "<img id=\"".concat(z, "\" class=\"army-tile\" src=\"/paths/img/army/").concat(this.mod.game.spaces['arbox'].units[z].back, "\" />");
          } else {
            arb.innerHTML += "<img id=\"".concat(z, "\" class=\"army-tile\" src=\"/paths/img/army/").concat(this.mod.game.spaces['arbox'].units[z].front, "\" />");
          }
        }
      }
      if (faction == 'central') {
        for (var _z = 0; _z < this.mod.game.spaces['crbox'].units.length; _z++) {
          if (this.mod.game.spaces['crbox'].units[_z].damaged) {
            arb.innerHTML += "<img id=\"".concat(_z, "\" class=\"army-tile\" src=\"/paths/img/army/").concat(this.mod.game.spaces['crbox'].units[_z].back, "\" />");
          } else {
            arb.innerHTML += "<img id=\"".concat(_z, "\" class=\"army-tile\" src=\"/paths/img/army/").concat(this.mod.game.spaces['crbox'].units[_z].front, "\" />");
          }
        }
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = ReservesOverlay;